export default __webpack_public_path__ + "static/media/contact.19902a58.png";